import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from '../../routes/routesConfig';
import { ArrowLeft } from '../../styles/svg/svgIcons';

export function BackButton({
  fallback = paths.homepage,
  replaceOnFallback = true,
  className,
  children = <ArrowLeft />,
}: {
  fallback?: string;
  replaceOnFallback?: boolean;
  className?: string;
  children?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  // Heuristic: can we go back?
  // - location.key === 'default' indicates initial entry in React Router v6+
  // - window.history.length > 1 indicates there is at least one prior entry
  const canGoBack =
    typeof window !== 'undefined' && window.history?.length > 1 && location.key !== 'default';

  const onClick = useCallback(() => {
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: replaceOnFallback });
    }
  }, [canGoBack, navigate, fallback, replaceOnFallback]);

  return (
    <div onClick={onClick} aria-disabled={!canGoBack} className={className}>
      {children}
    </div>
  );
}
